module.exports = __webpack_public_path__ + "static/media/interview_5.6ab7e17.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/interviews/interview_5.mp3
// module id = v6+2
// module chunks = 1